"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.PanoramaClusterMarker = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const Badge_1 = require("./Badge");
function PanoramaClusterMarker({ count }) {
    const size = 30;
    const smallerSize = size * 0.7;
    return ((0, jsx_runtime_1.jsxs)("div", { style: {
            transform: "translate(-50%, -50%)",
        }, children: [(0, jsx_runtime_1.jsx)("div", { style: {
                    backgroundColor: "#0275d8",
                    width: size,
                    height: size,
                    borderRadius: size,
                } }), (0, jsx_runtime_1.jsx)("div", { style: {
                    backgroundColor: "white",
                    width: smallerSize,
                    height: smallerSize,
                    borderRadius: size * 0.9,
                    position: "absolute",
                    top: "50%",
                    left: "50%",
                    transform: "translate(-50%, -50%)",
                    opacity: 0.9
                } }), (0, jsx_runtime_1.jsx)(Badge_1.Badge, { count: count, style: {
                    position: "absolute",
                    top: "50%",
                    left: "50%",
                    transform: "translate(-50%, -50%)"
                }, transparent: true })] }));
}
exports.PanoramaClusterMarker = PanoramaClusterMarker;
